import Image from 'next/legacy/image'
import styled from 'styled-components'

import { breakpoints } from '@/styles'

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  flex-direction: ${props => (props.reverse ? 'row-reverse' : 'row')};

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    flex-direction: column;
  }
`

const ImageWrapper = styled.div`
  position: relative;
  width: 50%;
  height: auto;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    height: 450px;
    width: 100%;
  }

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    height: 250px;
  }
`

const ItemsContainer = styled.div`
  width: 50%;
  min-height: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #445e54;
  color: #e0c6b4;
  padding: 50px 0 35px;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    min-height: unset;
    width: 100%;
    height: 100%;
  }
`

const TitleText = styled.p`
  font-size: 24px;
  margin-bottom: 10px;
`

const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: ${props => (props.large ? '530px' : '318px')};
  margin: 10px auto 0;
  @media (max-width: ${breakpoints.tabletLandscape}) {
    max-width: 318px;
  }
`

const Item = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 92px;
  margin: 10px 7px;
`

const ItemText = styled.p`
  height: ${props => (props.large ? '35px' : '15px')};
  width: 100%;
  font-size: 9px;
  margin-top: 10px;
  text-align: center;
`

const FeatureBlock = ({
  reverse = false,
  large = false,
  title,
  image,
  items
}) => {
  const mappedItems = items?.map(item => {
    return (
      <Item key={item.text}>
        <Image src={item.image} alt="" height={50} width={50} />
        <ItemText large={large}>{item.text}</ItemText>
      </Item>
    )
  })

  return (
    <Container reverse={reverse}>
      <ImageWrapper>
        <Image
          src={image}
          alt=""
          layout="fill"
          objectFit="cover"
          placeholder="blur"
        />
      </ImageWrapper>
      <ItemsContainer>
        <TitleText>{title}</TitleText>
        <Items large={large} alt="">
          {mappedItems}
        </Items>
      </ItemsContainer>
    </Container>
  )
}

export default FeatureBlock
